import React from 'react';
import QRCode from 'react-qr-code';

const QrBlock = ({ qrCode = '', qrRef, size }) => {
  return (
    <>
      <div ref={qrRef} itemScope itemType='https://schema.org/Offer'>
        <QRCode id='QRCodeScaled' size={size || 100} value={qrCode} />
      </div>
    </>
  );
};

export default QrBlock;
